import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';

const SvgComponent = (props: SvgProps) => {
  return (
    <Svg
      width={14}
      height={27}
      viewBox={'0 0 14 27'}
      {...props}
      fill={'none'}
      stroke={'none'}>
      <Path
        fill={props.fill || '#000'}
        fillRule="evenodd"
        d="M13.516 1.336a1.527 1.527 0 0 0-2.252 0L.687 12.555a1.403 1.403 0 0 0 0 1.904l10.577 11.218c.623.662 1.629.662 2.252 0a1.76 1.76 0 0 0 0-2.39L4.302 13.5l9.227-9.788c.61-.648.61-1.728-.013-2.376Z"
        clipRule="evenodd"
      />
    </Svg>
  );
};

export default SvgComponent;
